import { jwtDecode as jwt } from "jwt-decode";

export class AuthenticationFunctions {
  public static getTokenDataByKey = (key: string, accessToken: string): any => {
    const tokenDecode: { [x: string]: any } = jwt(accessToken);
    if (tokenDecode[key]) {
      return tokenDecode[key];
    }
    return null;
  };
}

